var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "elevation-12"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "indigo darken-4"
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.welcome')))]), _c('v-spacer'), _c('v-avatar', {
    attrs: {
      "tile": _vm.tile,
      "size": "32",
      "color": "grey lighten-4"
    }
  }, [_c('img', {
    attrs: {
      "src": "/img/mobile-info-192.png",
      "alt": "avatar"
    }
  })])], 1), _c('v-card-text', [_c('h2', [_vm._v(_vm._s(_vm.auth.username))]), _c('p', [_vm._v("\n      You have been invited to use the new "), _c('strong', [_vm._v("Mobile Info App")]), _vm._v(".\n      As this is your first time you will need to choose a password.\n    ")]), _c('p', [_vm._v("Please choose your password below...")]), _c('v-alert', {
    attrs: {
      "value": _vm.invalidCredentials,
      "color": "error"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$vuetify.t('$vuetify.app.invalidCredentials')) + "\n    ")]), _c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: _vm.valid,
      callback: function callback($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Username",
      "disabled": ""
    },
    model: {
      value: _vm.auth.username,
      callback: function callback($$v) {
        _vm.$set(_vm.auth, "username", $$v);
      },
      expression: "auth.username"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Password",
      "name": "password",
      "hint": "Password must be at least 8 characters",
      "id": "auth_password",
      "append-icon": _vm.e1 ? 'visibility' : 'visibility_off',
      "append-icon-cb": function appendIconCb() {
        return _vm.e1 = !_vm.e1;
      },
      "type": _vm.e1 ? 'password' : 'text',
      "rules": [_vm.auth.password != '' || 'field is required', _vm.auth.password.length > 7 || 'Password must be at least 8 characters'],
      "counter": ""
    },
    model: {
      value: _vm.auth.password,
      callback: function callback($$v) {
        _vm.$set(_vm.auth, "password", $$v);
      },
      expression: "auth.password"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Password Repeat",
      "name": "password_confirmation",
      "id": "auth_password_confirmation",
      "append-icon": _vm.e2 ? 'visibility' : 'visibility_off',
      "append-icon-cb": function appendIconCb() {
        return _vm.e2 = !_vm.e2;
      },
      "type": _vm.e2 ? 'password' : 'text',
      "rules": [_vm.auth.password === _vm.auth.password_confirmation || 'Password must match'],
      "counter": ""
    },
    model: {
      value: _vm.auth.password_confirmation,
      callback: function callback($$v) {
        _vm.$set(_vm.auth, "password_confirmation", $$v);
      },
      expression: "auth.password_confirmation"
    }
  }), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "left": ""
    },
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("Back")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "large": "",
      "dark": "",
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }